import API from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';
import Response from '../../classes/Response/Response';
import CustomError from '../../classes/CustomError/CustomError';

const ConfirmCodeService = () => {
  const verifyCode = async (validators) => {
    const api = new API(`${URL.URL_SERVER}/validators`);
    const http_response = await api.post(validators);
    const has_error = http_response instanceof CustomError;
    if (has_error) {
      return http_response;
    } else {
      const response = new Response(http_response);
      return !response.hasContent();
    }
  };

  const resendCode = async (email) => {
    const api = new API(`${URL.URL_SERVER}/users/${email}/validators`);
    const http_response = await api.post();
    const has_error = http_response instanceof CustomError;
    if (has_error) {
      return http_response;
    } else {
      const response = new Response(http_response);
      return !response.hasContent();
    }
  };

  return {
    verifyCode,
    resendCode,
  };
};

export default ConfirmCodeService;
